import { Navigate, Outlet, useLocation } from 'react-router-dom';

export function RequireFlowState({ stateKey, fallback }: { stateKey: string; fallback: string }) {
  const location = useLocation();
  const state = location.state as Record<string, unknown> | null;
  if (!state || state[stateKey] == null) return <Navigate to={fallback} replace />;
  return <Outlet />;
}
